<template>
  <div v-if="isOpen" class="routes-list"
       :class="{'routes-list--is-closed': !isOpen}"
  >
    <button class="btn-default routes-list__title"
            @click="isOpen = !isOpen"
    >
      <app-icon icon="arrow-right-double"
                class="routes-list__arrow-icon"
      />

      {{ $t("routesList.title") }}
    </button>

    <div class="routes-list__content"
    >
      <routes-list-new-item v-if="showNewItemTemplate"/>

      <routes-list-item v-for="route in routesList"
                        :key="route.id"
                        :route="route"
      />
    </div>
  </div>
</template>

<script>
import RoutesListNewItem from "@/components/common/RoutesList/RoutesListNewItem.vue";
import RoutesListItem from "@/components/common/RoutesList/RoutesListItem.vue";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "RoutesList",
  components: {
    RoutesListNewItem,
    RoutesListItem
  },
  computed: {
    ...mapState('Routes', ['routes']),
    ...mapState('Interface', ['isRoutesListOpen']),
    ...mapGetters('Interface', ['isRouteDetailsOpen']),

    isOpen: {
      get() {
        return this.isRoutesListOpen && !(this.isRouteDetailsOpen && this.$bp.isMdOrLess)
      },
      set(value) {
        this.setRoutesListOpenState(value)
      }
    },
    routesList() {
      return [...this.routes]
        .reverse()
    },
    showNewItemTemplate() {
      return this.routes.every(({ isNew }) => !isNew)
    }
  },
  methods: {
    ...mapActions('Interface',  ['setRoutesListOpenState'])
  }
}
</script>

<style lang="scss">
.routes-list {
  position: absolute;
  bottom:  $content-padding-bottom + 23px;
  right: calc($timeline-width + 28px);
  left: calc($sidebar-width + 28px);
  height: calc(100% - calc($content-padding-top + $content-padding-bottom + 530px + 35px));
  min-height: $itineraries-min-height;
  padding: 12px 25px 12px;
  background-color: $app-block-color;
  box-shadow: 0 4px 4px $app-box-shadow-color;
  z-index: 20;
  display: flex;
  flex-direction: column;
  transition: height 0.125s ease-in, min-height 0.125s ease-in;

  &--is-closed {
    right: auto;
    left: 50%;
    transform: translateX(-50%);
    height: $itineraries-closed-height;
    min-height: $itineraries-closed-height;
  }

  &__title {
    font-size: 35px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid $app-text-color !important;
    padding-bottom: 11px !important;
  }

  &__arrow-icon {
    transform: rotate(90deg);
    margin-right: 41px;
  }

  &__content {
    width: 100%;
    max-width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: auto;
    overflow-y: auto;
    overflow-x: hidden;

    @media screen and (max-width: 1630px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (max-width: 1360px) {
      grid-template-columns: 100%;
    }
  }

  &--is-closed &__title {
    border-bottom: none !important;
  }

  &--is-closed &__arrow-icon {
    transform: rotate(270deg);
  }

  &--is-closed &__content {
    display: none;
  }

}

@include smallerThan("xl") {
  .routes-list {
    right: 210px;
  }
}

@include smallerThan("lg") {
  $overflowed-navigator-items-sum-size: calc($mobile-navigator-item-size * 2);
  $routes-list-width: calc($overflowed-navigator-items-sum-size + $mobile-navigator-gap-width);

  .routes-list {
    right: unset;
    left: 50%;
    transform: translateX(-50%);
    width: $routes-list-width;
    bottom:  $content-padding-bottom + $mobile-navigator-item-size + 38px;

    &--is-closed {
      display: none;
    }

    .routes-list__title svg{
       display:none
    }
  }
}

@include smallerThan("md") {
  .routes-list {
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    transform: unset;

    &__arrow-icon {
      display: none;
    }

    .routes-list-new-item,
    .routes-list-item {
      padding-right: 0;
      padding-left: 0;
    }
  }
}
</style>
